import { render, staticRenderFns } from "./BookmarkMenuItem.htm?vue&type=template&id=ae03de92&scoped=true&"
import script from "./BookmarkMenuItem.ts?vue&type=script&lang=js&"
export * from "./BookmarkMenuItem.ts?vue&type=script&lang=js&"
import style0 from "./BookmarkMenuItem.scss?vue&type=style&index=0&id=ae03de92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae03de92",
  null
  
)

export default component.exports